import * as React from 'react'
import {useContext} from 'react'
import styled from 'styled-components'
import {Colors, FontWeights} from '../../../styledComponents/Constants'
import {Close} from '@mui/icons-material'
import {DialogCloseButton} from '../../reservations/components/CommonStyle'
import {RowFlexContainer} from '../../../styledComponents/FlexComponents'
import {AppAdminContext} from '../../../app/AppAdminContext'

export interface AdminPageHeadingAreaProps {
    title: string
    description?: string
    onClose?: () => void
}

export const AdminPageHeadingArea = (props: AdminPageHeadingAreaProps) => {
    const {showSpModePage} = useContext(AppAdminContext)
    return <>
        <StyledHeader $spMode={showSpModePage}>
            <RowFlexContainer>
                <div>
                    <span className={'admin-heading'}>
                        {props.title}
                    </span>
                    {
                        props.description &&
                        <span className={'admin-heading-sub'}>
                            {props.description}
                        </span>
                    }
                </div>
                {
                    props.onClose &&
                    <AdminDialogCloseButton onClick={props.onClose} id={'close'}>
                        <Close fontSize={showSpModePage ? 'large' : 'medium'}/>
                    </AdminDialogCloseButton>
                }
            </RowFlexContainer>
        </StyledHeader>
        {!showSpModePage &&
            <StyledHeadingHr/>
        }
    </>
}
AdminPageHeadingArea.displayName = 'AdminPageHeadingArea'

const StyledHeader = styled.header<{ $spMode: boolean }>`
  ${props => props.$spMode ? `
  color: ${Colors.AccentDark};
  line-height: 1.5;
  .admin-heading {
    font-size: 20px;
    font-weight: ${FontWeights.Bold};
  }
  .admin-heading-sub {
    padding-left: 10px;
    font-size: 14px;
  }
  ` : `
  padding: .25rem 0 .25rem .75rem;
  border-left: 10px solid ${Colors.AdminPrimary};
  line-height: 1.334;
  .admin-heading {
    font-size: 24px;
  }
  .admin-heading-sub {
    padding-left: 10px;
    color: ${Colors.AccentDark};
    font-size: 14px;
  }
  `}
`

const AdminDialogCloseButton = styled(DialogCloseButton)`
  margin: -10px;
`

const StyledHeadingHr = styled.hr`
  margin-block-start: 5px;
  border-style: solid;
  border-color: ${Colors.AdminPrimary};
`
